import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import ElevatedPaper, {
  DEFAULT_STYLE,
} from "../../../../../components/ElevatedPaper";
import CustomTabs from "../../../../../components/app/CustomTabs";
import { useDebounce } from "../../../../../hooks/use-debounce";
import AccountReceivableFilter from "./AccountReceivableFilter";
import {
  ACCOUNT_RECEIVABLE_TABS,
  AccountReceivableFilterType,
  AccountReceivableTab,
  DEFAULT_ACCOUNT_RECEIVABLE_FILTER,
} from "./account-receivable-constant";
import Flex from "../../../../../components/Flex";
import { roleFilter } from "../../../../../utils/utils";
import { useRoleController } from "../../../../../components/useRoleController";

const AccountReceivableLayout = () => {
  const [activeTab, setActiveTab] = useState<AccountReceivableTab>(
    location.pathname.split("/").pop() as AccountReceivableTab
  );

  const [filter, setFilter] = useState<AccountReceivableFilterType>(
    DEFAULT_ACCOUNT_RECEIVABLE_FILTER
  );
  const [search, setSearch, instantSearchVal] = useDebounce<string>("");

  const navigate = useNavigate();

  const { hasNone: hasNonePatient } = useRoleController("Account Receivables");
  const { hasNone: hasNoneInsurance } = useRoleController(
    "Pending Insurance Payment"
  );

  const handleTabChange = (v: string) => {
    navigate(`/app/provider/billing/account-receivable/${v}`);
    setActiveTab(v as AccountReceivableTab);
    setFilter(DEFAULT_ACCOUNT_RECEIVABLE_FILTER);
    setSearch("");
  };

  return (
    <ElevatedPaper
      sx={{ ...DEFAULT_STYLE, minHeight: "calc(100vh - 4.5rem)", padding: 2 }}
    >
      <Flex justifyContent="space-between" alignItems="center" mb={2}>
        <CustomTabs
          tabsData={roleFilter({
            list: ACCOUNT_RECEIVABLE_TABS,
            compWith: {
              patient: !hasNonePatient,
              insurance: !hasNoneInsurance,
            },
          })}
          value={activeTab}
          onChange={handleTabChange}
        />
        {/* Summary reports on the current day only, so it exposes no filters */}
        {activeTab !== "summary" && (
          <AccountReceivableFilter
            filter={filter}
            setFilter={setFilter}
            search={instantSearchVal}
            setSearch={setSearch}
          />
        )}
      </Flex>

      <Outlet
        context={{
          search,
          setSearch,
          filter,
          setFilter,
        }}
      />
    </ElevatedPaper>
  );
};

export default AccountReceivableLayout;
